import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import Img from 'gatsby-image'
import { Element, scroller } from 'react-scroll'

import Heading from '../components/heading'
import Footer from '../components/footer'
import Logo from '../components/logo/nucleus'
import Button from '../components/button'
import Form from '../components/form'
import Feature from '../components/feature'

import Section from '../components/section'
import Demonstration from '../components/demo'
import List from '../components/list'
import Carousel from '../components/carousel'
import Quote from '../components/quote'
import Modal from '../components/modal'

import HeroesSVG from '../assets/heroes.svg'


export default ({ data: { product, graphicA, graphicB, graphicC, graphicD, heroes } }) => {

    const [ openModal, setOpenModal ] = useState(false);
    
    return (
        <React.Fragment>
            <Layout>
                <Helmet>
                    <title>{product.title}</title>
                </Helmet>

                <Column elem={'header'}>
                    <Heading>
                        <h1>{product.title}</h1>
                        {product.subtitle && <div className="subtitle" dangerouslySetInnerHTML={{__html: product.subtitle.content.html}} />}

                        {product.data.introduction && <p>{product.data.introduction}</p>}

                        <ul className="buttons">
                            <li>
                                <Button onClick={() => scroller.scrollTo('info', {
                                    duration: 500,
                                    delay: 100,
                                    smooth: true,
                                    offset: -50,
                                })}>Find out more</Button>
                            </li>
                            <li>
                                <Button onClick={() => setOpenModal(true)}>Take a tour</Button>
                            </li>
                            <li>
                                <Button primary onClick={() => scroller.scrollTo('demo', {
                                    duration: 500,
                                    delay: 100,
                                    smooth: true,
                                    offset: -50,
                                })}>Request a demo</Button>
                            </li>
                        </ul>

                        {product.images && (
                            <Img 
                                Tag="figure" 
                                className="heading__screenshot" 
                                fluid={product.images[0].fluid} 
                                objectFit={'contain'}
                                alt={'Screenshot'} 
                            />
                        )}

                        {product.data.productFeatures && (
                            <ul className="features">
                            {product.data.productFeatures.map(feature => (
                                <li key={feature.icon}>
                                    <Feature {...feature} />
                                </li>
                            ))}
                            </ul>
                        )}
                    </Heading>
                </Column>

                {/*<Band color={'silver'}>
                    { graphicC && <div className={'graphic graphic--c'}><Img Tag={'figure'} fluid={graphicC.childImageSharp.fluid} alt={'Graphic C'} /></div>}
                    <Column>
                        <Element id="info" name="info" />
                        <Section style={{ padding: 0}}>
                                {product.data.demonstrat && (
                                    <header>
                                        <h2>{ product.data.demonstrationCopy.heading }</h2>
                                        <strong>{ product.data.demonstrationCopy.subheading }</strong>

                                        <span dangerouslySetInnerHTML={{ __html: product.data.demonstrationCopy.body }} />
                                    </header>
                                )}
                        
                                <Demonstration 
                                    steps={ product.data.demonstration }
                                    images={product.images}
                                
                                />

                        </Section>
                    </Column>
                                </Band>*/}


                <Column style={{paddingBottom: 0}}>
                    <Section>
                        <header>
                            <h2>UserCity benefits everyone</h2>
                            <strong>&hellip;and promotes a positive culture of lifelong learning, collaboration and unity.</strong>

                            <div className="section__list-set">
                            { product.data.benefits && product.data.benefits.map((list, i) => (
                                <List key={i}>
                                    <h4>{list.label}</h4>
                                    <ul>
                                        {list.bullets.map(bullet => (
                                            <li key={bullet}>{bullet}</li>
                                        ))}
                                    </ul>
                                </List>
                            ))}
                            {heroes && (
                                    <Img 
                                        Tag="figure" 
                                        fluid={heroes.childImageSharp.fluid} 
                                        objectFit={'contain'}
                                        alt={'heroes'} 
                                    />
                            ) }
                            </div>
                        </header>
                    </Section>
                </Column>

                <Band color={'silver'}>
                    <Column>
                        <Section>
                            <header>
                            <h2>Don't just take our word for it</h2>
                            </header>

                            <Carousel 
                                slides={product.quotes.map(quote => <Quote quote={quote.quote.content} cite={`${quote.citation}, ${quote.citationRole}`} />)}
                            />
                        </Section>
                    </Column>
                </Band>

                <Band color={'black'}>
                <Element id="demo" name="demo" />
                    <Column>
                        <Form />
                    </Column>
                </Band>

                <Column elem={'div'} className="logo">
                    <Logo />
                </Column>

                <Column elem={'footer'} role="contentinfo" className="footer">
                    <Footer graphic={graphicD} />
                </Column>

                { graphicA && <div className={'graphic graphic--a'}><Img Tag={'figure'} fluid={graphicA.childImageSharp.fluid} alt={'Graphic A'} /></div>}
                { graphicB && <div className={'graphic graphic--b'}><Img Tag={'figure'} fluid={graphicB.childImageSharp.fluid} alt={'Graphic B'} /></div>}

            </Layout>
            { openModal && (
                <Modal 
                    onClose={() => setOpenModal(false)}
                    bubbles={product.data.bubbles}
                />
            )}
        </React.Fragment>
    )
}


export const pageQuery = graphql`
  query productQuery {    
    product:contentfulProduct(contentful_id: { eq: "6hQC4mDWpFKUTRurtNUO8d" }) {
      title 
      subtitle {
        content:childMarkdownRemark {
            html
        }
      }
      data {
        introduction 
        productFeatures {
            body
            icon
            title
        }
        demonstration {
            label
            body
            figure
        }
        benefits {
            label
            bullets
        }
        demonstrationCopy {
            heading
            subheading
            body
        }
        bubbles {
            body
            label
        }
      }
      images {
            contentful_id
            fluid(maxWidth: 950, quality: 78) {
                ...GatsbyContentfulFluid_withWebp
            }
            fluidMedium:fluid(maxWidth: 650, quality: 70) {
                ...GatsbyContentfulFluid_withWebp
            },
            fluidSmall:fluid(maxWidth: 350, quality: 70) {
                ...GatsbyContentfulFluid
            }
      }
      quotes {
        citation
        citationRole
        quote {
          content:quote
        }
      }
    }

    graphicA: file(relativePath: { eq: "graphic-left-a.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
    }

    graphicB: file(relativePath: { eq: "graphic-right-b.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 900, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
    }

    graphicC: file(relativePath: { eq: "graphic-left-b.png" }) {
        childImageSharp {
          fluid(maxWidth: 900, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
    }

    graphicD: file(relativePath: { eq: "graphic-footer.png" }) {
        childImageSharp {
          fluid(maxHeight: 250, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
    }

    heroes: file(relativePath: { eq: "heroes.jpg" }) {
        childImageSharp {
          fluid(maxHeight: 550, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
    }
  }
`


const Layout = styled.div.attrs(props => ({

}))`
    --gutter: 24px;
    --black: #161616;
    --silver: #f4f4f4;
    --red: #cd0100;
    --white: #ffffff;
    --darkred: #930100;

    display: flex;
    flex-direction column;
    color: var(--black);
    min-height: 100vh;
    -webkit-font-smoothing: antialiased;

    > .logo {
        order: -1;
        padding-top: 2vh;
        padding-bottom: 0;
    }

    > .footer {
        margin-top: auto;
    }

    .graphic {
        position: absolute;
        z-index: -1;
        width: 20vw;
        height: 20vw;
    }

    .graphic--a {
        left: 0;
        top: 8vh;
    }

    .graphic--b {
        right: 0;
        top: 40vh;
        width: 32vw;
        height: 32vw;
        display: none;

        ${breakpoint('tablet')`
            display: block;
        `}
    }

    .graphic--c {
        left: 0;
        top: 45%;
        width: 32vw;
        height: 36vw;
        z-index: 0;
        transform: translateY(-50%);
        display: none;

        ${breakpoint('tablet')`
            display: block;
        `}
    }
`


const Band = styled.div.attrs(props => ({

}))`
    background-color: var(--${props => props.color});
    overflow: hidden;
    position: relative;
`


const Column = ({ elem = 'section', ...props }) => {
    
    const Component = styled(elem).attrs(passedProps => ({
        className: 'column'
    }))`
        max-width: 980px;
        margin-left: auto;
        margin-right: auto;
        padding-left: var(--gutter);
        padding-right: var(--gutter);
        padding-top: 5vmin;
        padding-bottom: 5vmin;
        width: 100%;
        position: relative;
        z-index: 2;
    `;

    return <Component {...props} />
}